import api from 'config/api.config';

/**
 * Fetch comments settings for a specific social media account.
 * @param social_media_account_id - The ID of the social media account.
 * @returns - The comments settings data.
 */
export const getLikesSettings = async (social_media_account_id: string): Promise<any> => {
  try {
    const response = await api.post(
      '/api/actions/likes/likes-settings',
      { social_media_account_id }
    );

    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to fetch comments settings');
  }
};

export const manageCommentsSettings = async (
  social_media_account_id: string,
  action_id: string,
  settings_type: string,
  operation: string,
  settings_value: any
): Promise<any> => {
  try {
    const response = await api.post(
      '/api/actions/likes/likes-settings-update',
      {
        social_media_account_id,
        action_id,
        settings_type,
        operation,
        settings_value
      }
    );

    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to fetch comments settings');
  }
};

export const getLikesSettingsLogs = async (
  account_id: string,
  page?: number,
  limit?: number,
  date?: string
): Promise<any> => {
  try {
    const body: any = { account_id };
    if (page !== undefined) body.page = page;
    if (limit !== undefined) body.limit = limit;
    if (date) body.date = date;

    const response = await api.post(
      '/api/actions/likes/likes-settings-logs',
      body
    );

    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to fetch likes settings logs');
  }
};
